export const name = 'presetsService';
export default function presetsService($http, $q, $log, templatesService) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let presetsServiceUrl = "/api/composer-service/v1/composer/presets";
  let pdfPresetsServiceUrl = "/api/composer-service/v1/composer/pdf-presets";

  return {
    getPresetsByPage,
    getPreset,
    getPredefinedPreset,
    addPreset,
    deletePresets,
    unlinkTemplates,
    updatePreset,
    duplicatePreset,
    setAsDefault,
    getLinkedTemplates,
    getPdfPresets,
    updatePdfPreset,
    addPdfPreset,
    uploadPdfPreset,
    deletePdfPreset,
    exportPdfPreset,
    duplicatePdfPreset,
    getLinkedPresets,
    unlinkPresets
  };

  function getPresetsByPage(page, pageSize, searchFilter, isLoadingRequired = true){
    let functionName = 'presetsService.getPresetsByPage';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', page:page, pageSize:pageSize}));

    let url = presetsServiceUrl + '/page';

    return $http({
      method: 'GET',
      url: url,
      params: {
        'page': page,
        'page-size': pageSize,
        'search-filter': searchFilter
      },
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'getPresetsByPage return with error', error:error.data}));
      });
  }

  function getPreset(presetId){
    let functionName = 'presetsService.getPreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', presetId:presetId}));

    let url = presetsServiceUrl + '/' + presetId;

    return $http({
      method: 'GET',
      url: url,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'getPreset return with error', error:error.data}));
      });
  }

  function getPredefinedPreset(){
    let functionName = 'presetsService.getPredefinedPreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called'}));

    let url = presetsServiceUrl + '/predefined';

    return $http({
      method: 'GET',
      url: url,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'getPreset return with error', error:error.data}));
      });
  }

  function updatePreset(updatedValues){
    let functionName = 'presetsService.updatePreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called'}));

    let url = presetsServiceUrl;

    return $http({
      method: 'PUT',
      url: url,
      data: updatedValues,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'updatePreset return with error', error:error.data}));
      });
  }

  function setAsDefault(presetId){
    let functionName = 'presetsService.setAsDefault';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', presetId: presetId}));
    let url = presetsServiceUrl + '/set-default/' + presetId;

    return $http({
      method: 'PUT',
      url: url,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'updatePreset return with error', error:error.data}));
      });
  }

  function addPreset(preset){
    let functionName = 'presetsService.addPreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', preset: preset}));

    let url = presetsServiceUrl;

    return $http({
      method: 'POST',
      url: url,
      data: preset,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'addPreset return with error', error:error.data}));
      });
  }

  function deletePresets(presetIdsToDelete){
    let functionName = 'presetsService.deletePreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', presetIdsToDelete: presetIdsToDelete}));

    let url = presetsServiceUrl;

    return $http({
      method: 'DELETE',
      url: url,
      data: presetIdsToDelete,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'addPreset return with error', error:error.data}));
      });
  }

  function duplicatePreset(presetId){
    let functionName = 'presetsService.duplicatePreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', presetId: presetId}));

    let url = presetsServiceUrl + "/duplicate/" + presetId;

    return $http({
      method: 'POST',
      url: url,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'addPreset return with error', error:error.data}));
      });
  }

  function getLinkedPresets(pdfPresetId){
    let functionName = 'presetsService.getLinkedPresets';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', pdfPresetId: pdfPresetId}));

    let url = pdfPresetsServiceUrl + "/in-use-presets/" + pdfPresetId;

    return $http({
      method: 'GET',
      url: url,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data.listOfElements;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'getLinkedTemplates return with error', error:error.data}));
      });
  }

  function getLinkedTemplates(presetIds){
    let functionName = 'presetsService.getLinkedTemplates';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', presetIds: presetIds}));

    let url = presetsServiceUrl + "/in-use-templates/" + presetIds;

    return $http({
      method: 'GET',
      url: url,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data.listOfElements;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'getLinkedTemplates return with error', error:error.data}));
      });
  }

  function unlinkTemplates(templateIdsToUnlink){
    let functionName = 'presetsService.unlinkTemplate';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', templateIdsToUnlink: templateIdsToUnlink}));

    let url = presetsServiceUrl + '/unlink-template';

    return $http({
      method: 'DELETE',
      url: url,
      data: templateIdsToUnlink,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'unlink templates return with error', error:error.data}));
      });
  }

  function unlinkPresets(presetsIdsToUnlink, typeOfPdfPreset){
    let functionName = 'presetsService.unlinkPresets';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', presetsIdsToUnlink: presetsIdsToUnlink}));

    let url = pdfPresetsServiceUrl + '/unlink-presets';

    let presetsUnlink = {
      presetIds: presetsIdsToUnlink,
      pdfPresetType: typeOfPdfPreset
    };

    return $http({
      method: 'DELETE',
      url: url,
      data: presetsUnlink,
      headers: {'Accept':'application/json','Content-Type':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'Unlink presets return with error', error:error.data}));
      });
  }

  //************************************************ PDF Presets ************************************************//

  function getPdfPresets(){
    let functionName = 'presetsService.getPdfPresets';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called'}));

    let url = pdfPresetsServiceUrl + '/list';

    return $http({
      method: 'GET',
      url: url,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'getPreset return with error', error:error.data}));
      });
  }

  function updatePdfPreset(updatedValues){
    let functionName = 'presetsService.updatePdfPreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called'}));

    let url = pdfPresetsServiceUrl + '/' + updatedValues.id;

    return $http({
      method: 'PUT',
      url: url,
      data: updatedValues,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'getPreset return with error', error:error.data}));
      });
  }

  function addPdfPreset(fieldsValues){
    let functionName = 'presetsService.savePdfPreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called'}));

    let url = pdfPresetsServiceUrl + '/';

    return $http({
      method: 'PUT',
      url: url,
      data: fieldsValues,
      headers: {'Accept':'application/json'}})
      .then(function (response) {
        return response.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'getPreset return with error', error:error.data}));
      });
  }

  function uploadPdfPreset(pdfPresetFile, uploadProgressCallback, uploadController, mimeType){
    let functionName = 'presetsService.uploadPdfPreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', filename:pdfPresetFile.name}));

    let defer = $q.defer();

    createEmptyPdfPresetEntry(pdfPresetFile).then(
      function (response) {
        $log.info(angular.toJson({
          functionName: functionName,
          action: 'createEmptyPdfPresetEntry completed successfully',
          storageAssetInfo: response
        }));

        let uploadIdentity = {
          name: pdfPresetFile.name,
        };

        uploadProgressCallback(null, response.id);
        let percentageReportInterval = 1;
        templatesService.uploadFileToStorageService(uploadIdentity, pdfPresetFile, response.storageId, percentageReportInterval, uploadProgressCallback, uploadController).then(
          function (storageAssetMetadata) {
            $log.info(angular.toJson({
              functionName: functionName,
              action: 'uploadFileToEntry completed successfully',
              storageAssetMetadata: storageAssetMetadata.data
            }));
            updatePdfPresetCompletionStatus(response.id).then(pdfPreset => {
              defer.resolve(pdfPreset);
            }, error => {
              defer.reject(error);
            });
          }, function (error) {
            $log.error(angular.toJson({
              functionName: functionName,
              action: 'uploadFileToStorageService return with error',
              error: error
            }));
            defer.reject(error);
          }
        );
      },
      function (error) {
        $log.error(angular.toJson({
          functionName: functionName,
          action: 'createEmptyFileEntry return with error',
          error: error.data
        }));
        defer.reject(error.data);
      }
    );

    return defer.promise;
  }

  function duplicatePdfPreset(pdfPresetId){
    let functionName = 'presetsService.duplicatePdfPreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called',pdfPresetId: pdfPresetId}));
    let defer = $q.defer();

    let url = pdfPresetsServiceUrl + '/duplicate/' + pdfPresetId;

    $http({method: 'POST', url: url,  headers: {'Accept':'application/json'}}).
    then(function(response){
      $log.log(angular.toJson({functionName:functionName, action:'function return with success', storageAssetInfo:response.data}));
      defer.resolve(response.data);
    },function(error) {
      $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
      defer.reject(error.status);
    });

    return defer.promise;
  }

  function createEmptyPdfPresetEntry(pdfPresetFile){
    let functionName = 'presetsService.createEmptyPdfPresetEntry';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called',filename:pdfPresetFile.name}));
    let defer = $q.defer();

    let url = pdfPresetsServiceUrl + '/pdf-preset';

    let pdfPresetEntryCreationRequest = {
      name: pdfPresetFile.name,
    };

    $http({method: 'POST', url: url, data: pdfPresetEntryCreationRequest, headers: {'Accept':'application/json'}}).
      then(function(response){
        $log.log(angular.toJson({functionName:functionName, action:'function return with success', storageAssetInfo:response.data}));
        defer.resolve(response.data);
      },function(error) {
        $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
        defer.reject(error.status);
      });

    return defer.promise;
  }

  function updatePdfPresetCompletionStatus(pdfPresetId){
    let functionName = 'presetsService.updatePdfPresetCompletionStatus';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called',pdfPresetId: pdfPresetId}));

    let defer = $q.defer();

    let url = pdfPresetsServiceUrl + "/" + pdfPresetId;

    let clientTimestampInMilliseconds = (new Date()).getTime() - (new Date()).getTimezoneOffset()*60*1000;

    let uploadCompletionStatus ={
      success: true,
      clientTimestampInMilliseconds: clientTimestampInMilliseconds,
    };

    $http({method: 'POST', url: url, data: uploadCompletionStatus, headers: {'Accept':'application/json'}}).
    then(function(response){
      $log.log(angular.toJson({functionName:functionName, action:'function return with success', template: response.data}));
      defer.resolve(response.data);
    },function(error) {
      $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
      defer.reject(error.data);
    });

    return defer.promise;
  }

  function exportPdfPreset(storageId){
    let functionName = 'presetsService.exportPdfPreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called',storageId: storageId}));
    let defer = $q.defer();

    let url = pdfPresetsServiceUrl + '/preassigned-url/' + storageId;

    $http({method: 'GET', url: url, headers: {'Accept':'text/plain'}}).
    then(function(response){
      $log.log(angular.toJson({functionName:functionName, action:'function return with success', storageAssetInfo:response.data}));
      defer.resolve(response.data);
    },function(error) {
      $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
      defer.reject(error.status);
    });
    return defer.promise;
  }

  function deletePdfPreset(presetId, pdfPresetId){
    let functionName = 'presetsService.deletePdfPreset';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called',pdfPresetId: pdfPresetId}));
    let defer = $q.defer();

    let url = pdfPresetsServiceUrl + '/' + parseInt(presetId) + '/' + pdfPresetId;

    $http({method: 'DELETE', url: url, headers: {'Accept':'application/json'}}).
    then(function(response){
      $log.log(angular.toJson({functionName:functionName, action:'function return with success', storageAssetInfo:response.data}));
      defer.resolve(response.data);
    },function(error) {
      $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
      defer.reject(error.status);
    });
    return defer.promise;
  }
}
